import { cn } from '@/lib/utils';
import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
}

/** Etiqueta de sección: píldora blush con texto frambuesa. */
export function SectionTag({
  children,
  className = ''
}: SectionTagProps) {
  return <span className={cn('inline-flex items-center gap-2 rounded-full border border-stone bg-sand px-3.5 py-1.5 font-display text-[0.66rem] font-bold uppercase tracking-editorial text-gold-deep', className)} data-id="element-205" data-mp="20t99ppmv3fvc">
      <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden data-id="element-206" data-mp="2fn5ghk3dc0gg" />
      {children}
    </span>;
}